(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["byam-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.byam-hero').forEach((hero)=>{if(hero.dataset.ready)return;hero.dataset.ready='true';const slides=[...hero.querySelectorAll('[data-slide]')];const dots=[...hero.querySelectorAll('[data-dot]')];if(slides.length<2)return;let index=0;let timer;const show=(next)=>{slides[index].classList.remove('is-active');if(dots[index])dots[index].setAttribute('aria-current','false');index=(next+slides.length)%slides.length;slides[index].classList.add('is-active');if(dots[index])dots[index].setAttribute('aria-current','true')};const start=()=>{clearInterval(timer);timer=setInterval(()=>show(index+1),Number(hero.dataset.autoplay)||5000)};hero.querySelector('[data-next]')?.addEventListener('click',()=>{show(index+1);start()});hero.querySelector('[data-previous]')?.addEventListener('click',()=>{show(index-1);start()});dots.forEach((dot,i)=>dot.addEventListener('click',()=>{show(i);start()}));hero.addEventListener('mouseenter',()=>clearInterval(timer));hero.addEventListener('mouseleave',start);if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches)start()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["byam-home-content"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.byam-gift-finder').forEach((finder) => {
    const buttons = Array.from(finder.querySelectorAll('[data-byam-filter]'));
    const select = finder.querySelector('[data-byam-kind]');
    const products = Array.from(finder.querySelectorAll('[data-byam-product]'));
    const results = finder.querySelector('[data-byam-results]');
    const empty = finder.querySelector('[data-byam-empty]');
    const requested = new URLSearchParams(window.location.search).get('feeling');
    let feeling = buttons.some((button) => button.dataset.byamFilter === requested) ? requested : 'all';
    let kind = 'all';
    const applyFilters = () => {
      let visible = 0;
      products.forEach((product) => {
        const feelingMatch = feeling === 'all' || product.dataset.moment === feeling || product.dataset.moment === 'all';
        const kindMatch = kind === 'all' || product.dataset.kind === kind;
        const show = feelingMatch && kindMatch;
        product.hidden = !show;
        if (show) visible += 1;
      });
      results.textContent = `${visible} thoughtful ${visible === 1 ? 'idea' : 'ideas'}`;
      empty.hidden = visible !== 0;
    };
    buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.byamFilter === feeling));
      button.addEventListener('click', () => {
        feeling = button.dataset.byamFilter;
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        applyFilters();
      });
    });
    select.addEventListener('change', () => { kind = select.value; applyFilters(); });
    applyFilters();
  });

  document.querySelectorAll('[data-byam-review-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-byam-review-slide]'));
    const previous = carousel.querySelector('[data-byam-review-prev]');
    const next = carousel.querySelector('[data-byam-review-next]');
    const dotsMount = carousel.querySelector('[data-byam-review-dots]');
    let current = 0;
    const dots = slides.map((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Show customer review ${index + 1}`);
      dot.addEventListener('click', () => show(index));
      dotsMount.appendChild(dot);
      return dot;
    });
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === current)));
    };
    if (slides.length > 0) {
      previous.addEventListener('click', () => show(current - 1));
      next.addEventListener('click', () => show(current + 1));
      show(0);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
